import React from "react";
import GeneralButtonWithText from "../helpers/GeneralButtonWithText";
import { UIProperties } from "../UIProperties";

import './ConfirmAlertUI.css'

const ConfirmAlertUI = (props: UIProperties<ConfirmAlertUIProps>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container modal-bg modal-disable-select">
			<div aria-label='Confirm' className="confirm-container center-on-container">
				<img src="./assets/images/general/backgrounds/modal.png"/>
				<p className="modal-title confirm-font">Confirm</p>
				<div className="confirm-desc-container">
					<div style={{
						width: '580px',
						position: 'absolute',
						height: '245px',
						margin: '20px'
					}}>
						<p className="confirm-desc" style={{
							position: 'absolute',
							top: '30px',
							left: '0'
						}} tabIndex={0} id='confirm-alert-first-object'>{props.parameters.text}</p>
						<div style={{
							position: 'relative',
							height: '100px',
							top: '200px'
						}}>
							<GeneralButtonWithText parameters= {{
								text: props.parameters.yesBttnText ? props.parameters.yesBttnText : 'Yes',
								top: '0',
								left: '30px',
								width: '215px',
								highlightOnHover: true,
								onClicked: () => {
									props.parameters.onYes();
								}
							}}/>

							<GeneralButtonWithText parameters= {{
								text: props.parameters.noBttnText ? props.parameters.noBttnText : 'No',
								top: '0',
								id: 'confirm-alert-last-object',
								left: '330px',
								width: '215px',
								highlightOnHover: true,
								onClicked: () => {
									props.parameters.onNo();
								}
							}}/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export interface ConfirmAlertUIProps {
	text: string;
	onYes: () => void;
	onNo: () => void;
	yesBttnText?: string,
	noBttnText?: string
}

export default ConfirmAlertUI;